import { fillCircleText } from './fillCircleText';

const colors = {
  kellyMooreLemonBurst: '#FFEF99',
  goldenYellow: '#F5A70E',
  imperialYellow: '#FFBE40',
  bananaYellow: '#FFE040',
};

export function drawWinAmount(ctx, winAmount) {
  ctx.fillText(winAmount, 0, -40);
}

export function drawText(ctx, winMessage, centerX, centerY, radius) {
  const gradient = ctx.createRadialGradient(0, 90, 0, 90, 90, 183.41);

  gradient.addColorStop(0.45, colors.kellyMooreLemonBurst);
  gradient.addColorStop(0.6, colors.goldenYellow);
  gradient.addColorStop(0.645, colors.imperialYellow);
  gradient.addColorStop(0.72, colors.bananaYellow);
  ctx.fillStyle = gradient;

  fillCircleText(ctx, winMessage.toUpperCase(), { centerX, centerY, radius, start: -Math.PI / 2 });
}

export function drawStraightText(ctx, winMessage, centerX) {
  const linearGradient = ctx.createLinearGradient(0, 90, 0, 180);
  linearGradient.addColorStop(0.1, colors.kellyMooreLemonBurst);
  linearGradient.addColorStop(0.485, colors.goldenYellow);
  linearGradient.addColorStop(0.692, colors.imperialYellow);
  linearGradient.addColorStop(0.75, colors.bananaYellow);

  ctx.font = 'bold 44px sans-serif';
  ctx.fillStyle = linearGradient;

  ctx.fillText(winMessage.toUpperCase(), centerX, 160);
}

export function drawRect(ctx, winMessage, canvas) {
  const txtWidth = ctx.measureText(winMessage.toUpperCase()).width;
  const stripSize = 110;
  const point = {
    x: (canvas.width - txtWidth) / 2,
    y: 100,
  };

  // Background gradient
  const linearGradient = ctx.createLinearGradient(
    0,
    point.y,
    canvas.width,
    0
  );
  linearGradient.addColorStop(0, 'rgba(0,0,0,0)');
  linearGradient.addColorStop(0.10, 'rgba(0,0,0,0.05)');
  linearGradient.addColorStop(0.20, 'rgba(0,0,0,0.3)');
  linearGradient.addColorStop(0.40, 'rgba(0,0,0,0.65)');
  linearGradient.addColorStop(0.72, 'rgba(0,0,0,0.65)');
  linearGradient.addColorStop(0.80, 'rgba(0,0,0,0.3)');
  linearGradient.addColorStop(0.90, 'rgba(0,0,0,0.05)');
  linearGradient.addColorStop(1, 'rgba(0,0,0,0)');

  ctx.fillStyle = linearGradient;
  ctx.fillRect(point.x, point.y, txtWidth, stripSize);
}

export function drawFan(ctx, canvas, end = 375) {
  const outerCircleRadius = 250;
  const stripSize = 100; // size of the strip where we display the text

  const innerCircleRadius = outerCircleRadius - stripSize;
  const point = {
    x: 250,
    y: 375,
  };

  ctx.beginPath();
  ctx.arc(point.x, point.y, outerCircleRadius, Math.PI, 0);
  ctx.lineTo(canvas.width - stripSize, end);
  ctx.moveTo(stripSize, end);
  ctx.arc(point.x, point.y, innerCircleRadius, Math.PI, 0);
  ctx.moveTo(stripSize, end);
  ctx.lineTo(0, end);
  ctx.closePath();

  // Stripe gradient
  const radialGradient = ctx.createRadialGradient(250, 0, 250, 250, 0, 450);
  radialGradient.addColorStop(0.13, 'rgba(0,0,0,1)');
  radialGradient.addColorStop(0.25, 'rgba(0,0,0,0.75)');
  radialGradient.addColorStop(0.5, 'rgba(0,0,0,0.2)');
  radialGradient.addColorStop(0.75, 'rgba(0,0,0,0.1)');
  radialGradient.addColorStop(0.95, 'rgba(0,0,0,0)');

  ctx.fillStyle = radialGradient;
  ctx.fill();

  ctx.save();
  ctx.globalCompositeOperation = 'destination-out';
  ctx.beginPath();
  ctx.arc(point.x, point.y, innerCircleRadius, Math.PI, 0);
  ctx.lineTo(stripSize, end);
  ctx.closePath();
  ctx.fillStyle = '#000';
  ctx.fill();
  ctx.restore();

  ctx.beginPath();
  ctx.arc(point.x, point.y, innerCircleRadius, Math.PI, 0);
  ctx.closePath();

  // Background gradient
  const linearGradient = ctx.createLinearGradient(
    canvas.width / 2,
    0,
    canvas.width / 2,
    canvas.height
  );
  linearGradient.addColorStop(0, 'rgba(0,0,0,0.2)');
  linearGradient.addColorStop(1, 'rgba(0,0,0,0.3)');

  ctx.fillStyle = linearGradient;
  ctx.fill();
}

export function easeInOutQuart(x) {
  // eslint-disable-next-line
  return x < 0.5 ? 8 * x * x * x * x : 1 - Math.pow(-2 * x + 2, 4) / 2;
}
